var map = {
	"./companyadmin/companyadmin.module": [
		"./src/app/allmodule/companyadmin/companyadmin.module.ts",
		"default~companyadmin-companyadmin-module~src-app-allmodule-allmodule-module~tgadmin-tgadmin-module~t~dfe05b16",
		"default~companyadmin-companyadmin-module~tgadmin-tgadmin-module~tgds-admin-tgds-admin-module",
		"common",
		"companyadmin-companyadmin-module"
	],
	"./tgadmin/tgadmin.module": [
		"./src/app/allmodule/tgadmin/tgadmin.module.ts",
		"default~companyadmin-companyadmin-module~src-app-allmodule-allmodule-module~tgadmin-tgadmin-module~t~dfe05b16",
		"default~companyadmin-companyadmin-module~tgadmin-tgadmin-module~tgds-admin-tgds-admin-module",
		"common",
		"tgadmin-tgadmin-module"
	],
	"./tgds-admin/tgds-admin.module": [
		"./src/app/allmodule/tgds-admin/tgds-admin.module.ts",
		"default~companyadmin-companyadmin-module~src-app-allmodule-allmodule-module~tgadmin-tgadmin-module~t~dfe05b16",
		"default~companyadmin-companyadmin-module~tgadmin-tgadmin-module~tgds-admin-tgds-admin-module",
		"common",
		"tgds-admin-tgds-admin-module"
	],
	"src/app/allmodule/allmodule.module": [
		"./src/app/allmodule/allmodule.module.ts",
		"default~companyadmin-companyadmin-module~src-app-allmodule-allmodule-module~tgadmin-tgadmin-module~t~dfe05b16",
		"common",
		"src-app-allmodule-allmodule-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;